import { MapUiTheme } from '../../common';

export const dropdownTheme = {
  defaultStyles: {
    display: 'inline-block',
    position: 'relative',
  },
  trigger: {
    cursor: 'pointer',
  },
  content: {
    position: 'absolute',
    zIndex: (theme: MapUiTheme) => theme.zIndices.dropdown,
  },
  direction: {
    top: {
      transform: 'translateY(-100%)',
    },
    right: {
      left: '0',
    },
    bottom: {},
    left: {
      right: '0',
    },
  },
};
